exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboard-questionnaire__item:before{content:none}.message-holder{padding:20px;width:100%;height:100%;display:flex;flex-direction:column;text-align:center;align-items:center}.message-holder h3{font-size:18px;color:#676767;margin-bottom:30px;font-weight:700}.message-holder p{text-align:center;font-size:1.5rem;color:#37383d;font-weight:700;margin-bottom:50px}", ""]);

// exports
